import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { MinimumResponse } from 'src/app/models/minimum-response.model'

@Injectable({
  providedIn: 'root',
})
export class MinimumService {
  public static readonly minimumEndpoint = '/minimum'

  constructor(private readonly http: HttpClient) {}

  getMinimum(fundId: string): Observable<MinimumResponse> {
    return this.http.get<MinimumResponse>(
      `vmf/api/${fundId}`.concat(MinimumService.minimumEndpoint),
    )
  }
}
